import React from "react";
import { FaPlayCircle } from "react-icons/fa";
import "./VideoSection.css";

const VideoSection = () => {
  return (
    <section className="luxury-video-section">
      <div className="video-background"></div>
      <div className="video-card">
        <div className="luxuryvideo-frame">
          <iframe
            src="https://www.youtube.com/embed/ewP9VfUaBvc?autoplay=1&mute=1&controls=1&loop=1&playlist=ewP9VfUaBvc"
            title="Interior Design Inspiration"
            allow="autoplay; encrypted-media"
            allowFullScreen
            frameBorder="0"
          ></iframe>
          <FaPlayCircle className="play-icon" />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
